class Elementor_Service {
    static instance;

    static getInstance() {
        if (!Elementor_Service.instance) {
            Elementor_Service.instance = new Elementor_Service();
        }
        return Elementor_Service.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-service.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        });
    }
}

Elementor_Service.getInstance();

